module.exports = __webpack_public_path__ + "static/img/3areaB_18.8e08008.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_18.png
// module id = 1169
// module chunks = 1